import { CiCircleCheck } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { getApiInstance } from "../../../utils/api";
import i18n from "../../../i8n";

// Piezas compartidas por la pestaña "Visitas" de la ficha del gestor y la
// pagina de Informes de visitas: catalogo de valoraciones, secciones del
// informe y el formateo de la fecha.

// Valoracion global de un informe de visita (indice = codValoracion en BD)
// Las etiquetas son getters: salen siempre en el idioma activo.
const conEtiqueta = (obj, clave) =>
    Object.defineProperty(obj, "label", {
        get: () => i18n.t(clave),
        enumerable: true,
    });

export const VALORACIONES_VISITA = ["1", "2", "3"].map((value) =>
    conEtiqueta({ value }, `visits.ratings.${value}`)
);

export const BADGE_VALORACION_VISITA = {
    1: conEtiqueta({ type: "success", Icon: CiCircleCheck }, "visits.ratings.1"),
    2: conEtiqueta({ type: "warning", Icon: CgDanger }, "visits.ratings.2"),
    3: conEtiqueta({ type: "danger", Icon: CgDanger }, "visits.ratings.3"),
};

// Secciones de texto largo del informe, en el orden en el que se leen
export const SECCIONES_INFORME_VISITA = [
    "introduccion",
    "objetivos",
    "descripcionInstalacion",
    "desarrollo",
    "observaciones",
    "conclusiones",
    "recomendaciones",
].map((key) => conEtiqueta({ key }, `visits.sections.${key}`));

// La fecha llega como "2025-12-12T00:00:00"; se corta en seco para no
// arrastrar desfases de zona horaria ni en la tabla ni en el input date.
export const soloFecha = (valor) => (valor ? String(valor).slice(0, 10) : "");

export const formatFechaVisita = (valor) => {
    const fecha = soloFecha(valor);
    return fecha ? fecha.split("-").reverse().join("/") : "";
};

// El API devuelve el ISO completo; el input date y los filtros de fecha
// necesitan "YYYY-MM-DD".
export const mapVisitas = (lista) =>
    (Array.isArray(lista) ? lista : []).map((visita) => ({
        ...visita,
        fechaVisita: soloFecha(visita.fechaVisita),
    }));

// El header trae filename= y filename*=UTF-8''...; se prioriza este ultimo
// porque es el que conserva las tildes del nombre.
const nombreFicheroDescarga = (contentDisposition, porDefecto) => {
    if (!contentDisposition) return porDefecto;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1]);
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return fileNameMatch && fileNameMatch[1] ? fileNameMatch[1] : porDefecto;
};

// Descarga el Word (.docx) de un informe de visita concreto. Lanza si falla:
// cada pantalla decide como avisar al usuario.
export const descargarInformeVisitaWord = async (visita) => {
    const codVisita = visita?.codVisita;

    if (!codVisita) return;

    const api = getApiInstance();
    const response = await api.get(
        `/api/ProveedoresVisitas/CreateReportVisitaWord/${codVisita}`,
        { responseType: "blob" }
    );

    const fileName = nombreFicheroDescarga(
        response.headers["content-disposition"],
        `Informe_Visita_${codVisita}.docx`
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
